import PropTypes from 'prop-types';

const Delete = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.81302 7.95023L4.43297 5.57018L5.66974 4.33342L8.04979 6.71347L10.4298 4.33344L11.6666 5.5702L9.28655 7.95023L11.6667 10.3304L10.4299 11.5671L8.04979 9.187L5.66963 11.5672L4.43286 10.3304L6.81302 7.95023Z"
      fill="#0D0D0D"
    />
  </svg>
);

Delete.propTypes = {
  className: PropTypes.string
};

export default Delete;
